"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Navigation_1 = __importDefault(require("./Navigation"));
const DefaultLayout = (props) => {
    return (react_1.default.createElement("div", { className: "min-h-screen bg-gray-100 flex flex-col" },
        react_1.default.createElement(Navigation_1.default, null),
        react_1.default.createElement("div", { className: "py-2 flex flex-1" },
            react_1.default.createElement("main", { className: "mx-auto w-full flex lg:px-4" }, props.children))));
};
exports.default = DefaultLayout;
